import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useIsomorphicLayoutEffect } from './hooks';

const useResponsive = () => {
    const [isMounted, setIsMounted] = useState(false);

    const isVerySmallMobile = useMediaQuery({
        maxWidth: 330,
    });

    const isSmallerMobile = useMediaQuery({
        maxWidth: 380,
    });

    const isSmallMobile = useMediaQuery({
        maxWidth: 450,
    });

    const isSmallBreakpoint = useMediaQuery({
        maxWidth: 599,
    });

    const isMobile = useMediaQuery({
        maxWidth: 700,
    });

    const isSmallTablet = useMediaQuery({
        maxWidth: 925,
    });

    const isTablet = useMediaQuery({
        maxWidth: 1100,
    });

    const isLargeTablet = useMediaQuery({
        maxWidth: 1320,
    });

    const isSmallDesktop = useMediaQuery({
        maxWidth: 1450,
    });

    const isDesktop = useMediaQuery({
        maxWidth: 2400,
    });

    useIsomorphicLayoutEffect(() => {
        setIsMounted(true);
    }, []);

    return {
        isMobile: isMounted ? isMobile : false,
        isTablet: isMounted ? isTablet : false,
        isLargeTablet: isMounted ? isLargeTablet : false,
        isSmallDesktop: isMounted ? isSmallDesktop : false,
        isDesktop: isMounted ? isDesktop : false,
        isSmallTablet: isMounted ? isSmallTablet : false,
        isVerySmallMobile: isMounted ? isVerySmallMobile : false,
        isSmallMobile: isMounted ? isSmallMobile : false,
        isSmallerMobile: isMounted ? isSmallerMobile : false,
        isSmallBreakpoint: isMounted ? isSmallBreakpoint : false,
        isMounted,
    };
};

export default useResponsive;
